import { FindReferenceColorsToOfflineOutput } from '../../../../../../../../../services/modules/referenceColors/referenceColors.types';
import { OfflineDatabaseReferenceColor } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseReferenceColor.types';
import { offlineReferenceColorsRepository } from '../../../../../../../repositories/offlineReferenceColors.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class ReferenceColorsQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindReferenceColorsToOfflineOutput>({
      url: '/colors/reference-colors/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineReferenceColorsRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(data: FindReferenceColorsToOfflineOutput): OfflineDatabaseReferenceColor {
    return {
      id: data.id,
      name: data.name,
    };
  }
}
